<div class="iackathon-intro-page__header">
    <h1 class="iackathon-intro-page__title">
        IAckathon
    </h1>
</div>

<div class="iackathon-intro-page__content">
    <ul class="iackathon-intro-page__description-list">
        @for (description of descriptions; track description.title) {
            <li class="iackathon-intro-page__description-item">
                <article class="iackathon-intro-page__description-article">
                    <div class="iackathon-intro-page__description-icon-wrapper">
                        <mat-icon class="iackathon-intro-page__description-icon"
                                  [svgIcon]="description.icon">
                        </mat-icon>
                    </div>
                    <h2 class="iackathon-intro-page__description-title">
                        {{ description.title | translate }}
                    </h2>
                    <p class="iackathon-intro-page__description-text">
                        {{ description.text | translate }}
                    </p>
                </article>
            </li>
        }
    </ul>
    <div class="iackathon-intro-page__actions">
        <a class="iackathon-intro-page__action-link"
           [routerLink]="['/iackathon']">
            <span>{{ 'iackathon.launch' | translate }}</span>
            <mat-icon svgIcon="play_arrow_rounded_fill"></mat-icon>
        </a>
        <a class="iackathon-intro-page__action-link"
           [routerLink]="['/iackathon-deliverables']">
            <span>{{ 'iackathon.deliverable_library' | translate }}</span>
            <mat-icon svgIcon="folder"></mat-icon>
        </a>
    </div>
</div>
